import React from 'react';
import { IGameFeed } from '@pvplevelup/core/dist/queries/game/gameFeed';
import { ICharacter } from '@pvplevelup/core/dist/interfaces/ICharacter';
import { ProfileGames } from 'components/Profile/ProfileGames';

interface Props {
  character: ICharacter | undefined | null;
  gameFeed: IGameFeed | undefined;
  fetchMoreRecords: ()=>void;
}

/** The character page's Game History tab. */
const CharacterGames: React.FC<Props> = ({gameFeed,fetchMoreRecords}) => {
  return (
    <ProfileGames gameFeed={gameFeed} fetchMoreRecords={fetchMoreRecords} />
  );
};

export {CharacterGames};
